// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"5e2b1b9c","178":"158c1172","250":"4270054e","488":"bb0f069b","654":"508d0692"}[chunkId] + ".chunk.js";
};